import { application } from 'src';
import { Controller } from '@hotwired/stimulus';
import { advanceDate, isPresent, isValidDate,  min } from '@fretadao/f-js-utils';

application.register(
  'precedent-dates',
  class extends Controller {
    static targets = ['firstDate', 'lastDate'];
    static values = {
      maxDifferenceInDays: { type: Number, default: 90 },
      dateMaxToday: { type: Boolean, default: false }
    };

    connect() {
      if (this.dateMaxTodayValue) {
        const today = new Date();
        this.firstDateTarget.max = this.#dateToString(today);
      }
    }

    adjustLastDateMin() {
      const firstDate = this.firstDateTarget.value;
      if (!isValidDate(firstDate, { locale: 'en' })) return;

      const lastDate = this.lastDateTarget.value;

      if (isValidDate(lastDate, { locale: 'en' })) {
        const firstDateObject = this.#dateObjectFor(firstDate);
        const lastDateObject = this.#dateObjectFor(lastDate);

        if (lastDateObject < firstDateObject) this.lastDateTarget.value = firstDate
      }

      this.lastDateTarget.min = firstDate;
    }

    adjustLastDateMax() {
      const firstDate = this.firstDateTarget.value;
      const lastDate = this.lastDateTarget.value;
      const today = new Date();
      const referenceDate = isValidDate(firstDate, { locale: 'en' }) ? this.#dateObjectFor(firstDate) : today;

      const limitDateObject = advanceDate(referenceDate, this.maxDifferenceInDaysValue, 'days');

      this.lastDateTarget.max = this.#dateToString(min([today, limitDateObject]));
    }

    adjustLastDate() {
      this.#clearLastDate();
      this.adjustLastDateMin();
      this.adjustLastDateMax();
    }

    #dateObjectFor(date) {
      return new Date(`${date}T00:00:00.000Z`);
    }

    #dateToString(date) {
      return date.toISOString().split('T')[0];
    }

    /**
     * Clear the last date field.
     * @private
     */
    #clearLastDate(){
      this.lastDateTarget.value = '';
      this.lastDateTarget.min = '';
      this.lastDateTarget.max = ''; 
    }
  }
);
